import {apiback, get} from '../../../config';
import {LANG} from '../../../services/l10n';

export default {
    create: function() {
        let lang = get('LANG');

        const typeConfig = {
            'kid-card': {
                hash: 'D6F08E241D9F6EFC'
            },
            referal: {
                hash: '92UZDG8M6TPBEISG'
            },
            default: {
                hash: '4RR2342L90V22AE7'
            }
        };

        const type = this.get('type');
        const currentType = typeConfig[type] || typeConfig['default'];

        const data = {
            conv_data: {
                ...this.get('utmParams'),
                client_name: this.get('name'),
                phone: this.get('phone').toString(),
                utm_manager:
                    this.get('utm_manager') !== null ? this.get('utm_manager') : this.get(''),
                utm_source: this.get('utm_source') !== null ? this.get('utm_source') : this.get(''),
                utm_comment:
                    this.get('utm_comment') !== null ? this.get('utm_comment') : this.get(''),
                utm_campaign:
                    this.get('utm_campaign') !== null ? this.get('utm_campaign') : this.get(''),
                utm_medium: this.get('utm_medium') !== null ? this.get('utm_medium') : this.get(''),
                utm_term: this.get('utm_term') !== null ? this.get('utm_term') : this.get(''),
                utm_content:
                    this.get('utm_content') !== null ? this.get('utm_content') : this.get(''),
                product: type
            },
            // hash: this.get('type') === 'kid-card' ? 'D6F08E241D9F6EFC' : '4RR2342L90V22AE7'
            hash: currentType.hash
        };

        if (this.get('type') === 'kid-card') {
            data.conv_data.age = this.get('checkbox') ? 'child' : 'per';
        }

        return {
            url: apiback('API_COREZOID'),
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: data,
            cache: false
        };
    }
};
